<template>
  <v-container fluid class="eci-container">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-row>
        <!-- Header / Foto + info principal -->
        <v-col cols="12">
          <photo-card :personalData="personalData" :stateList="stateList" />
        </v-col>

        <!-- Cards Docs / Notas / Emails -->
        <v-col cols="12">
          <cards-info-panel
            :infoCards="infoCards"
            :routesConfigNoteCard="routesConfigNoteCard"
            :personalData="personalData"
            :emailRoutesConfig="emailRoutesConfig"
            @getData="getData"
          />
        </v-col>

        <v-col cols="12">
          <information-data-panel
            :personalData="personalData"
            :stateList="stateList"
            :routesConfig="routesConfig"
            :canEdit="canEdit"
            @getData="getData"
          />
        </v-col>

        <v-col cols="12">
          <roles-data-panel
            :personalData="personalData"
            :routesConfig="routesConfig"
            :canEdit="canEdit"
            @getData="getData"
          />
        </v-col>

        <v-col cols="12" v-if="canSeeSecurityPanel">
          <security-data-panel
            :personalData="personalData"
            :routesConfigPassword="routesConfigPassword"
            :canEdit="canEdit"
            @getData="getData"
          />
        </v-col>

        <!-- Bloque: Roles y funciones -->
        <v-col
          cols="12"
          v-if="hasNotAlianzaId && (showManagerRole || isAdminProfile)"
        >
          <v-sheet class="eci-section">
            <v-row class="px-6 py-4">
              <v-col cols="12">
                <h3 class="section-title">Roles y funciones</h3>
              </v-col>

              <v-col cols="12" v-if="showManagerRole">
                <AssignedDataPanel :contactData="contactData" />
              </v-col>

              <v-col cols="12" v-if="isAdminProfile">
                <documents-data-panel :idProspecto="contactData.idProspecto" />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </template>

    <!-- Versión móvil -->
    <template v-else>
      <v-row class="mobile-layout">
        <v-col cols="12">
          <photo-card :personalData="personalData" :stateList="stateList" />
        </v-col>

        <!-- Datos Generales primero en móvil -->
        <v-col cols="12">
          <v-sheet class="eci-section">
            <v-row class="px-4 py-3">
              <v-col cols="12">
                <h3 class="section-title">Datos Generales</h3>
              </v-col>

              <v-col cols="12">
                <personal-data-panel
                  :personalData="personalData"
                  :stateList="stateList"
                  :routesConfig="routesConfig"
                  :canEdit="canEdit"
                  @getData="getData"
                />
              </v-col>

              <v-col cols="12">
                <contact-data-panel
                  :correosDataFormat="correosDataFormat"
                  :contactData="contactData"
                  :routesContactData="routesContactData"
                  :canEdit="canEdit"
                  @getData="getData"
                />
              </v-col>

              <v-col cols="12" v-if="canSeeSecurityPanel">
                <security-data-panel
                  :personalData="personalData"
                  :routesConfigPassword="routesConfigPassword"
                  :canEdit="canEdit"
                  @getData="getData"
                />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>

        <!-- Roles y funciones -->
        <v-col
          cols="12"
          v-if="hasNotAlianzaId && (showManagerRole || isAdminProfile)"
        >
          <v-sheet class="eci-section">
            <v-row class="px-4 py-3">
              <v-col cols="12">
                <h3 class="section-title">Roles y funciones</h3>
              </v-col>

              <v-col cols="12" v-if="showManagerRole">
                <AssignedDataPanel :contactData="contactData" />
              </v-col>

              <v-col cols="12" v-if="isAdminProfile">
                <documents-data-panel :idProspecto="contactData.idProspecto" />
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>

        <!-- Cards de Docs / Notas / Emails al final en móvil -->
        <v-col cols="12">
          <cards-info-panel
            :infoCards="infoCards"
            :routesConfigNoteCard="routesConfigNoteCard"
            :personalData="personalData"
            :emailRoutesConfig="emailRoutesConfig"
            @getData="getData"
          />
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import PhotoCard from "./PhotoCard.vue";
import PersonalDataPanel from "../components/personalData/PersonalDataPanel.vue";
import InformationDataPanel from "../components/informationData/InformationDataPanel.vue";
import ContactDataPanel from "../components/contactData/ContactDataPanel.vue";
// import ProfileCard from "../components/profileData/ProfileCard.vue";
import DocumentsDataPanel from "../components/documentsData/DocumentsDataPanel.vue";
import CardsInfoPanel from "../components/cardsInfo/CardsInfoPanel.vue";
import AssignedDataPanel from "../components/ProfileAssigned/AssignedDataPanel.vue";
import { mainAxios } from "@/mainAxios";
import moment from "moment";
import RolesDataPanel from "../components/rolFuncionesData/RolesDataPanel.vue";
import SecurityDataPanel from "../components/securityData/SecurityDataPanel.vue";

export default {
  components: {
    PhotoCard,
    PersonalDataPanel,
    ContactDataPanel,
    DocumentsDataPanel,
    AssignedDataPanel,
    // ProfileCard,
    CardsInfoPanel,
    InformationDataPanel,
    RolesDataPanel,
    SecurityDataPanel,
  },

  data() {
    return {
      config: {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      },
      personalData: {
        rol: "",
      },
      stateList: [],
      correosList: [],
      routes: {},
      routesConfig: {
        completeData: true,
        route: "",
        action: "PUT",
      },
      contactData: {
        celular: "",
        telefono: "",
        idAgente: null,
        idProspecto: null,
      },
      routesConfigPassword: {
        route: "",
        action: "POST",
        uuidCambio: "",
      },
      infoCards: {
        notas: [],
        docs: [],
        emails: [],
      },
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      routesConfigNoteCard: {
        route: "",
        action: "POST",
      },
      correosDataFormat: {
        correos: [],
        action: "POST",
      },
      routesContactData: {
        routeCommond: "",
        routeCommondAction: "PUT",
        deleteEmails: "/v1/correo-contacto/delete",
        changeEmails: "/v1/correo-contacto/update/", //query param idCorreo para modificar correo
        insertEmails: "/v1/correo-contacto/insert",
      },
      emailRoutesConfig: {
        sendEmailRoute: "",
        action: "",
        optionCorreosList: [],
        destinatario: "",
      },
      screenWidth1: window.innerWidth,
      canEdit: false,
      hasNotAlianzaId: false,
      isAdminProfile: false,
      showManagerRole: false,
    };
  },

  methods: {
    getDataContact() {
      if (!this.$route.params.uuid) {
        mainAxios
          .get("/v1/agente/uuid/" + localStorage.agenteUuid, this.config)
          .then((data) => {
            this.contactData.nombreCompleto = data.data.nombreCompleto;
            this.contactData.correo = data.data.correo;
            this.contactData.celular = data.data.celular;
            this.contactData.telefono = data.data.telefono;
            this.contactData.idAgente = data.data.id;
            this.contactData.idProspecto = data.data.idProspecto;
            this.hasNotAlianzaId =
              !data.data.alianzaId || data.data.alianzaId === 0;
          });
      } else {
        mainAxios
          .get("/v1/agente/uuid/" + this.$route.params.uuid, this.config)
          .then((value) => {
            this.contactData.nombreCompleto = value.data.nombreCompleto;
            this.contactData.correo = value.data.correo;
            this.contactData.celular = value.data.celular;
            this.contactData.telefono = value.data.telefono;
            this.contactData.idAgente = value.data.id;
            this.contactData.idProspecto = value.data.idProspecto;
            this.hasNotAlianzaId =
              !value.data.alianzaId || value.data.alianzaId === 0;
          });
      }
    },
    getUserData() {
      this.infoCards.notas = [];
      this.infoCards.docs = [];
      var route = "";
      if (typeof this.$route.params.uuid != "undefined") {
        route = "/v1/agente/uuid/" + this.$route.params.uuid;
        this.routesConfig.route = `/v1/agente/update/${this.$route.params.uuid}`;
        this.routesContactData.routeCommond = `/v1/agente/update/${this.$route.params.uuid}`;
      } else {
        route = "/v1/agente/uuid/" + localStorage.agenteUuid;
        this.routesConfig.route = `/v1/agente/update/${localStorage.agenteUuid}`;
        this.routesContactData.routeCommond = `/v1/agente/update/${localStorage.agenteUuid}`;
      }

      mainAxios.get(route, this.config).then((value) => {
        this.formatPersonalData(value.data);
        this.getCorreos(value.data);
        this.formatNotasDocumentos(value.data.documentos);
        this.formatCorreosInfoCard(value.data.correos);
      });
    },

    routesConfigPasswordConfig() {
      if (
        this.rol === "ADMIN" ||
        this.rol === "ADMINAGENT" ||
        this.rol === "ADMINCC" ||
        this.rol === "MANAGER" ||
        this.rol === "DIRECTOR" ||
        this.rol === "OPERACIONES" ||
        this.rol === "OPERACIONESINBOUND" ||
        this.rol === "BACKOFFICEEMAILS"
      ) {
        this.routesConfigPassword.route = "/v1/agente/admin/password/update";
        this.routesConfigPassword.uuidCambio =
          this.$route.params.uuid || localStorage.agenteUuid;
      } else {
        this.routesConfigPassword.route = "/v1/agente/admin/password/update";
        this.routesConfigPassword.uuidCambio = localStorage.agenteUuid;
      }
    },
    formatPersonalData(data) {
      this.personalData.id = data.id ?? null;
      this.personalData.uuid = data.uuid ?? null;
      this.personalData.correo = data.username ?? null;
      this.personalData.nombre = data.nombre ?? null;
      this.personalData.apellidoPaterno = data.apellidoPaterno ?? null;
      this.personalData.apellidoMaterno = data.apellidoMaterno ?? null;
      this.personalData.celular = data.celular ?? null;
      this.personalData.telefono = data.telefono;
      this.personalData.callCenter = data.callCenter ?? null;
      this.personalData.fechaNacimiento = moment(
        data.fechaNacimiento,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");
      this.personalData.sexo = data.sexo ?? null;
      const rawEstado = data?.nacimientoEstadoId;

      // si viene null/undefined/"undefined"/"" -> 9
      const estadoSeguro =
        rawEstado === null ||
        rawEstado === undefined ||
        rawEstado === "" ||
        String(rawEstado).toLowerCase() === "undefined"
          ? 9
          : Number(rawEstado);

      this.personalData.nacimientoEstadoId = estadoSeguro;
      this.personalData.rfc = data.rfc ?? null;
      this.personalData.curp = data.curp ?? null;
      this.personalData.status = data.status ? data.status : 0;
      this.personalData.rol = data.roles[0] ? data.roles[0].rol : data.rol;

      localStorage.setItem("rolNotAdmin", this.personalData.rol);
      localStorage.setItem("callCenterId", this.personalData.callCenter)
      this.personalData.ramos = data.ramos ?? null;
      this.personalData.canales = data.canales ?? null;
      this.personalData.landings = data.landings ?? null;
      this.personalData.fuenteIngreso = data.fuenteIngreso ?? null;
      this.personalData.regimen = data.regimen ?? null;
      this.personalData.agenteAsociadoPromotoria =
        data.agenteAsociadoPromotoria ?? null;
      this.personalData.tipoAgente = data.tipoAgente ?? null;
      this.personalData.razonSocial = data.razonSocial ?? null;
      this.personalData.clabeBancaria = data.clabeBancaria ?? null;
      this.personalData.claveAgente = data.claveAgente ?? null;
      this.personalData.tipoCedula = data.tipoCedula ?? null;
      this.personalData.nivelAgente = data.nivelAgente ?? null;
      this.personalData.numeroCartera = data.numeroCartera ?? null;
      this.personalData.cedula = data.cedula ?? null;
      this.personalData.rc = data.rc ?? null;
      this.personalData.vigenciaCedula = data.vigenciaCedula
        ? moment(data.vigenciaCedula, "YYYY-MM-DD").format("DD/MM/YYYY")
        : null;
      this.personalData.vigenciaPolizaRc = data.vigenciaPolizaRc
        ? moment(data.vigenciaPolizaRc, "YYYY-MM-DD").format("DD/MM/YYYY")
        : null;
      this.personalData.fecha_ingreso = data.fecha_ingreso
        ? moment(data.fecha_ingreso, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")
        : null;
      this.personalData.turno = data.turno ? data.turno : null;
      this.personalData.motivoBaja = data.motivoBaja ? data.motivoBaja : null;
      this.personalData.vip = data.vip ? data.vip : false;
      this.routesConfigNoteCard.route = `/v1/agente/documento/upload/${data.id}`;
      this.personalData.status = data.status ? data.status : 0;
      this.personalData.numero_colaborador = data.numero_colaborador
        ? data.numero_colaborador
        : null;
      this.personalData.cuentas_correo = data.cuentasCorreo ?? null;
      this.personalData.areas_negocio = data.areasNegocio ?? null;
      this.personalData.empresas = data.empresas ?? null;
      this.personalData.extension = data.extension ?? null;
      this.personalData.area = data.area ?? null;
      this.personalData.estatusAsignacion = data.estatusAsignacion ?? 1;
      this.canEditMethod();
    },

    getCorreos(data) {
      mainAxios
        .get(`v1/agente/list/correos-contacto/${data.id}`, this.config)
        .then((value) => {
          this.formatCorreos(value.data);
        });
    },
    formatCorreos(correos) {
      // Filtrar correos válidos
      const correosFiltrados = correos.filter(
        (correo) => correo.correo !== null && !correo.error
      );
      // Limpiar el array de destino
      this.correosDataFormat.correos = [];

      // Mapear los correos filtrados y asignarlos
      correosFiltrados.map((c) => {
        this.correosDataFormat.correos.push({
          id: c.id,
          uuid: c.uuid,
          correo: c.correo,
          prospecto_id: c.prospecto_id,
          favorito: c.favorito,
        });
      });

      // Calcular las rutas de correos
      this.calculateRoutesEmails();
    },
    formatCorreosInfoCard(correos) {
      this.infoCards.emails = [];
      correos.map((e) => {
        this.infoCards.emails.push({
          showInfo:
            e.subject +
            +" " +
            moment
              .utc(e.fecha)
              .subtract(6, "hours")
              .format("DD/MM/YYYY") +
            " " +
            e.subject.slice(0, 10) +
            " ... " +
            moment
              .utc(e.fecha)
              .subtract(6, "hours")
              .format("HH:mm"),
          dateFormat: moment
            .utc(e.fecha)
            .subtract(6, "hours")
            .format("DD/MM/YYYY HH:mm"),
          Onlyfecha: moment
            .utc(e.fecha)
            .subtract(6, "hours")
            .format("DD/MM/YYYY"),
          hora: moment
            .utc(e.fecha)
            .subtract(6, "hours")
            .format("HH:mm"),
          url_documento: e.documentos ? e.documentos[0].url_bucket : false,
          ...e,
        });
      });
      this.calculateRoutesEmails();
    },

    formatNotasDocumentos(docs) {
      this.infoCards.notas = [];
      this.infoCards.docs = [];
      docs.map((e) => {
        if (e.tipoRegistro == "Nota" || e.tipoRegistro == "nota")
          this.infoCards.notas.push({
            formatData:
              moment
                .utc(e.fecha)
                .subtract(6, "hours")
                .format("DD/MM/YYYY") +
              " " +
              e.detalle.slice(0, 10) +
              " ... " +
              moment
                .utc(e.fecha)
                .subtract(6, "hours")
                .format("HH:mm"),
            dateFormat: moment
              .utc(e.fecha)
              .subtract(6, "hours")
              .format("DD/MM/YYYY HH:mm"),
            url: e.url_bucket,
            ...e,
          });
        else {
          this.infoCards.docs.push({
            dateFormat: moment
              .utc(e.fecha)
              .subtract(6, "hours")
              .format("DD/MM/YYYY HH:mm"),
            onlyDate: moment
              .utc(e.fecha)
              .subtract(6, "hours")
              .format("DD/MM/YYYY"),
            url: e.url_bucket,
            ...e,
          });
        }
      });
    },

    getStates() {
      mainAxios.get("/v1/catalogo/estado", this.config).then((value) => {
        this.stateList = value.data;
      });
    },
    calculateRoutesEmails() {
      this.emailRoutesConfig.sendEmailRoute = "/v1/portal/agente/correo/enviar";
      this.emailRoutesConfig.action = "POST";
      this.emailRoutesConfig.optionCorreosList = this.correosDataFormat.correos;
      this.emailRoutesConfig.remitente = localStorage.agenteMail;
      this.emailRoutesConfig.usuario = this.personalData.id;
    },
    getData() {
      this.getUserData();
      this.getStates();
      this.routesConfigPasswordConfig();
    },
    updateScreenSize() {
      this.screenWidth1 = window.innerWidth;
    },
    canEditMethod() {
      var permitedRoles = [];
      if (window.location.pathname.includes("/usuario/ver-micuenta")) {
        switch (this.rol) {
          case "ADMIN":
            this.canEdit = true;
            break;
          case "ADMINAGENT":
            permitedRoles = ["MANAGER", "AGENT", "AGENTCORP", this.rol];
            break;
          case "MANAGER":
            permitedRoles = ["AGENT", this.rol];
            break;
          case "ADMINCC":
            permitedRoles = [
              "MANAGERCC",
              "AGENTCC",
              "OPERADORCC",
              "AGENTCCSPONSORS",
              "RENOVACIONESCC",
              "COBRANZACC",
              this.rol,
            ];
            break;
          case "AGENTCC":
            this.canEdit = true;
            break;
          case "MANAGERCC":
            permitedRoles = ["AGENTCC", "OPERADORCC", this.rol];
            break;
          case "OPERACIONES":
            permitedRoles = ["OPERADOR", "AGENT", this.rol];
            break;
          case "MANAGEREMAILS":
            permitedRoles = ["BACKOFFICEEMAILS", "OPERACIONESEMAILS", this.rol];
            break;
          case "FORMACION":
          case "ADMINCCALIANZAS":
          case "AGENTCCALIANZAS":
          case "MANAGERCCALIANZAS":
          case "OPERADORCCALIANZAS":
            this.canEdit = false;
            break;
          case "OPERADORCC":
          case "COBRANZACC":
          case "RENOVACIONESCC":
          case "OPERADORINBOUND":
          case "BACKOFFICEEMAILS":
          case "OPERACIONESINBOUND":
            permitedRoles = [];
            this.canEdit = true;
            break;
          case "GERENTEPOSTVENTA":
            permitedRoles = [
              "BACKOFFICEEMAILS",
              "OPERACIONESINBOUND",
              "OPERACIONESEMAILS",
              "MANAGEREMAILS",
              "OPERADORINBOUND",
              this.rol,
            ];
            this.canEdit = true;
            break;
          default:
            this.canEdit = true;
        }
        if (permitedRoles.includes(this.personalData.rol)) this.canEdit = true;
        //else if (this.rol != "ADMIN") this.canEdit = true;
      } else this.canEdit = true;
    },
    //function to manage the visibility of the documents panel
    showNonAdminInfo() {
      const uuid = this.$route.params.uuid;
      const roles = JSON.parse(localStorage.getItem("roles")) || [];

      return uuid && roles.some((role) => role.rol === "ADMINAGENT");
    },

    //function to manage the visibility of the assigned data panel
    showManager() {
      const uuid = this.$route.params.uuid;
      const roles = JSON.parse(localStorage.getItem("roles")) || [];

      return uuid
        ? roles.some((role) => ["ADMINAGENT", "AGENT"].includes(role.rol))
        : this.rol === "AGENT";
    },
  },
  computed: {
    canSeeSecurityPanel() {
      const allowed = [
        "ADMIN",
        "ADMINCCALIANZAS",
        "ADMINCC",
        "MANAGERCCALIANZAS",
        "MANAGERCC",
        "GERENTEPOSTVENTA",
        "MANAGEREMAILS",
        "MANAGERINBOUND",
        "OPERACIONESEMAILS",
        "OPERACIONESINBOUND",
      ];

      //Accion secundaria en caso de que no detecte el rol en el localStorage
      const rol =
        this.rol || JSON.parse(localStorage.getItem("roles"))?.[0]?.rol;
      return allowed.includes(rol);
    },
  },

  mounted() {
    this.getDataContact();
    this.getData();
    this.isAdminProfile = this.showNonAdminInfo();
    this.showManagerRole = this.showManager();
    this.personalData = Object.assign({
      nombre: "",
      apellidoPaterno: "",
      apellidoMaterno: "",
      nacimientoEstadoId: 9,
    });
    window.addEventListener("resize", this.updateScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenSize);
  },
};
</script>

<style scoped>
.eci-container {
  min-height: calc(100vh - 80px);
  padding-bottom: 0;
  box-sizing: border-box;
  background: #f6f5f9;
}

/* Card tipo maqueta */
.eci-section {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  margin: 12px 24px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

/* Móvil */
@media (max-width: 959px) {
  .mobile-layout {
    display: flex;
    flex-direction: column;
    padding: 8px;
    padding-bottom: 220px;
  }

  .mobile-layout .v-col {
    margin-bottom: 12px;
  }

  .eci-section {
    margin: 8px 0;
    border-radius: 16px;
  }
}
</style>
